import BadgeModal from './badge-modal-view';

export default BadgeModal;
